<template>
  <div>
    <search-bar
      @search="searchSaleOut"
      name="pi_custname,pr_detail,pi_seller"
      placeholder="输入客户、物料、业务员进行查找"
      ref="searchBar"
    />
    <filter-bar @change="searchSaleOut" :filters="filters" ref="filterBar" />

    <div class="weui-cells">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="(item, index) in list"
        :key="index"
        :to="{ name: 'SaleOutDetail', params: { item } }"
      >
        <div class="weui-cell__bd">
          <p>{{ item.pi_custname }}</p>
          <p class="list-item-muted">{{ item.pi_inoutno }}</p>
          <p>{{ item.pr_detail }}</p>
          
        </div>
        <div class="weui-cell__ft">
          <p class="list-item-muted">&nbsp; {{ item.pi_seller }}</p>
          <p v-format="'#,##0.#'">￥{{ item.ordertotal }}</p>
          <p class="list-item-muted">{{ item.pr_brand }}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">
            {{ item.pi_date }}
          </p>
        </div>
      </router-link>
    </div>
    <div class="height-50"></div>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ list.length }}单</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{
        ordertotal
      }}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";

export default {
  props: ["condition"],
  components: {
    SearchBar,
    FilterBar,
  },
  data() {
    return {
      list: [], // 销售出货明细列表
      ordertotal: 0,
      filters: [
        {
          type: "date",
          // name: ""
        },
      ],
      localcondition: this.condition,
    };
  },
  mounted() {
    if (this.localcondition) {
      this.conditionalQuery();
    } else {
      this.searchSaleOut();
    }
  },
  methods: {
    conditionalQuery() {
      let me = this;
      if (me.localcondition.keyword) {
        me.$refs.searchBar.focuing = true;
      }
      me.$refs.searchBar.keyword = me.localcondition.keyword;

      me.$refs.filterBar.parsedFilters[0].value = -1;
      me.searchSaleOut();
    },
    searchSaleOut(keyword) {
      let me = this;

      let filterBar = me.$refs.filterBar;
      let k = me.$refs.searchBar.keyword;
      let dateFilter = me.$refs.filterBar.parsedFilters[0];
      let period = dateFilter.fn(dateFilter.value, dateFilter, filterBar).value;
      if (period === "undefined,undefined") {
        if (this.localcondition?.date) {
          period = this.localcondition?.date;
        } else {
          period = this.localcondition?.yearmonth;
        }
      }
      let params = null,
        searchText = '';
      params = {
        number: 1,
        size: 99999,
        mode: "DETAIL",
        condition: [
          {
            type: "date",
            field: "pi_date",
            operation: "between",
            value: period,
          },
          {
            type: "condition",
            value:
              " pi_class in ( 'SALEOUT','SALERETURN') and PI_STATUS='已审核'",
          },
        ],
        calculateFields: JSON.stringify([
          { field: "outqty", operation: "sum" },
          { field: "pi_currency", operation: "max" },
          { field: "taxamount", operation: "sum" },
          { field: "nettotal", operation: "sum" },
          { field: "ordertotal", operation: "sum" },
        ]),
        page: 1,
        start: 0,
        limit: 99999,
        // filter: [{"type":"string","operation":"c","operationText":"包含","label":"部门","field":"department.dp_name","value":"总"}]
      };

      if (keyword) {
        if (me.localcondition && me.localcondition.keyword) {
          me.localcondition.keyword = null;
        }
        searchText = keyword;
      }
      if (k && me.localcondition?.keyword) {
        searchText = me.localcondition?.keyword;
      }
      if (searchText != '') {
        params.condition.push({
          type: "condition",
          value:
            "(pi_custname like '%" +
            searchText +
            "%' or pr_detail like '%" +
            searchText +
            "%' or pi_seller like '%" +
            searchText +
            "%' or pr_brand like '%" +
            searchText +
            "%' or cu_type like '%" +
            searchText +
            "%' or pi_inoutno like '%" +
            searchText +
            "%' or pr_spec like '%" +
            searchText +
            "%' or pr_orispeccode like '%" +
            searchText +
            "%' or pd_prodcode like '%" +
            searchText +
            "%' or pr_brand like '%" +
            searchText +
            "%')",
        });
      }
      params.condition = JSON.stringify(params.condition);

      me.$ajax({
        url: "/api/storage/report/saleOut",
        params,
      }).then(function (res) {
        if (res.success) {
          me.list = res.data.list.list;
          if (res.data?.calculate?.length > 0) {
            me.ordertotal = res.data.calculate[0].ordertotal;
          } else {
            me.ordertotal = 0;
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.height-50 {
  height: 50px;
}
.weui-cell {
  align-items: flex-start !important;
}
.conditional-row {
  background-color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.conditional-text {
  display: flex;
  width: 60%;
  align-items: center;
  color: #9b9b9b;
  font-size: 12px;
  margin: 0px 10px;
}
.conditional-text > span {
  height: 30px;
  line-height: 30px;
}
.conditional-value {
  width: 80px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #666;
  font-size: 12px;
  margin: 0px 5px;
}
.clear-button {
  margin: 0px 4px;
  font-size: 12px;
  color: #2296f8;
}
</style>